import React, { useCallback } from 'react';
import { useBlotterConfigurationSelector } from 'widgets/blotter/store/configuration/selectors';
import { useBlotterComponentSelectedRowIdsSelector } from 'widgets/blotter/store/components/selectors';
import { useDispatchBlotterComponentsSetSelectedRowIdsAction } from 'widgets/blotter/store/components/dispatcher';
import { ColumnDefinitionsDictionary } from '@instinet-analytics/semantic-ui-components';
import FiltersModal from 'utils/components/FiltersModal/FiltersModal';

import { BlotterColumn } from 'widgets/blotter/columns/ColumnPortfolio';
import { useDispatchUpdateFilters } from 'widgets/store/grid/filters/dispatcher';
import { useOrdersStateSelector } from 'app/store/orders/selectors';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

export interface BlotterFiltersModalProps {
    columnDefinitions: ColumnDefinitionsDictionary<BlotterColumn>;
    blotterId: string;
    trigger: React.ReactElement;
}

export default function BlotterFiltersModal({
    blotterId,
    columnDefinitions,
    trigger,
}: BlotterFiltersModalProps) {
    const { visibleColumns, filters } =
        useBlotterConfigurationSelector(blotterId);
    const selectedRowIdxs =
        useBlotterComponentSelectedRowIdsSelector(blotterId);

    const { editedColumnNames } = useWidgetEditedColumnNames();

    const updateFilters = useDispatchUpdateFilters();
    const setSelectedRows =
        useDispatchBlotterComponentsSetSelectedRowIdsAction();

    const { data } = useOrdersStateSelector();

    const onUpdateSelectedRows = useCallback(
        (selectedRowIdxs: number[]) => {
            setSelectedRows(blotterId, selectedRowIdxs);
        },
        [blotterId, setSelectedRows]
    );

    return (
        <FiltersModal
            columnDefinitions={columnDefinitions}
            editedColumnNames={editedColumnNames}
            data={data}
            visibleColumns={visibleColumns}
            filters={filters}
            selectedRowIndexes={selectedRowIdxs}
            trigger={trigger}
            onUpdateFilters={updateFilters}
            onUpdateSelectedRows={onUpdateSelectedRows}
        />
    );
}
